import { DARK, RED, WHITE } from 'constants/colors';
import { brightness } from 'utils/misc';
import { getActivityTypeColor } from '../../utils';
import { ZoomLevel as DetailZoomLevel } from '../../components/Header/ZoomLevelMenu.enums';

interface ChipDragPreviewPragmaticProps {
  width: number;
  isClient: boolean;
  isAbsent: boolean;
  isRecurring?: boolean;
  selected: boolean;
  hasWarnings: boolean;
  detailZoomLevel?: number;
  label: string;
}

// Provider-free chip replica for `setCustomNativeDragPreview` — the detached
// preview tree has no Recoil/Redux/Context, so plain inline-styled divs only.
export default function ChipDragPreviewPragmatic({
  width,
  isClient,
  isAbsent,
  isRecurring,
  selected,
  hasWarnings,
  detailZoomLevel,
  label
}: ChipDragPreviewPragmaticProps) {
  'use memo';
  const height = detailZoomLevel === DetailZoomLevel.COMPACT ? '20px' : '40px';
  const backgroundColor = hasWarnings ? brightness(RED, 90) : WHITE;
  const colorBarColor = getActivityTypeColor(isClient, isAbsent);

  return (
    <div
      style={{
        display: 'flex',
        zIndex: 30,
        alignItems: 'center',
        borderRadius: '2px',
        boxSizing: 'border-box',
        minHeight: '16px',
        overflow: 'hidden',
        boxShadow: selected
          ? `0px 0px 0px 2px ${DARK}`
          : '0px 1px 18px rgba(0, 0, 0, 0.15)',
        width: `${width}px`,
        height,
        backgroundColor,
        cursor: 'grabbing'
      }}
    >
      <div
        style={{
          height: '100%',
          minWidth: isRecurring ? '4px' : '2px',
          backgroundColor: colorBarColor,
          marginRight: '4px',
          flexShrink: 0
        }}
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          flex: 1
        }}
      >
        <div
          style={{
            whiteSpace: 'nowrap',
            fontSize: '12px',
            height: '18px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textDecoration: isAbsent ? 'line-through' : 'none',
            paddingRight: '4px'
          }}
        >
          {label}
        </div>
      </div>
    </div>
  );
}
